import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, capitalize } from 'lodash';
import shortid from 'shortid';

const FigureRow = ({ figures, type }) => (
    isEmpty(figures) ? null : (
        <div className="hp-raceRecords__figuresRow">
            <span>{capitalize(type)} placings: </span>&nbsp;
            {[...figures].reverse().map(({ raceTypeCode, formFigure }) => (
                ['X', 'P'].includes(raceTypeCode) ? (
                    <strong key={shortid.generate()}>
                        {formFigure}
                    </strong>
                ) : formFigure
            ))}
        </div>
    )
);

FigureRow.propTypes = {
    figures: PropTypes.arrayOf(PropTypes.shape({
        raceTypeCode: PropTypes.string,
        formFigure: PropTypes.string,
    })),
    type: PropTypes.string.isRequired,
};

export default FigureRow;



// WEBPACK FOOTER //
// ./src/js/horse/form/raceRecords/FigureRow.jsx